import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import smoothscroll from 'smoothscroll-polyfill';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import Footer from './layout/footer';
import Header from './layout/header';
import LogoutCounter from './layout/logoutCounter';
import LoginFormContainer from './login/loginFormContainer';
import routes from '../routes';
import entityComposition from './common/classes/entityComposition';

/**
 * Needed to support scrollTo on Edge
 */
smoothscroll.polyfill();

// define main App component including redux wrapper.
class App extends Component {
  componentDidMount() {
    const loginActions = this.props.loginActions;
    loginActions.getUserFromSession();
  }
  render() {
    const location = this.props.location;
    // Check if we're on the Entra callback route
    // Don't render Header/Footer during Entra callback to prevent premature API calls
    // (ConfigBehavior and CustomerSettings API calls can interfere with authentication flow)
    const isEntraCallbackRoute = (location === null || location === void 0 ? void 0 : location.pathname) === '/auth/callback' || typeof window !== 'undefined' && (
    // eslint-disable-next-line no-undef
    window.location.pathname === '/auth/callback'
    // eslint-disable-next-line no-undef
    || window.location.hash.includes('/auth/callback')
    // eslint-disable-next-line no-undef
    || window.location.hash.includes('code='));
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LoginFormContainer, null, !isEntraCallbackRoute && /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement(DndProvider, {
      backend: HTML5Backend
    }, routes), !isEntraCallbackRoute && /*#__PURE__*/React.createElement(Footer, null), !isEntraCallbackRoute && /*#__PURE__*/React.createElement(LogoutCounter, null))));
  }
}
App.propTypes = {
  loginActions: PropTypes.shape({
    getUserFromSession: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  })
};
App.defaultProps = {
  location: undefined
};

// Connect the App.
// Wrap the ConnectedClass `withRouter` to ensure route location updates are handled.
// more details: https://tinyurl.com/y9oq9aub
const ConnectedApp = withRouter(entityComposition(App, [], {
  customer: state => state.login.customer
}, ['login']));
export { App as TestApp };
export default ConnectedApp;